import { map } from 'lodash';
import React from 'react';

import { IRoute } from '@/interface/router';

export function renderRoutes(routes: IRoute[]): IRoute[] {
  return map(routes, (item: any) => {
    const res: any = { ...item };
    if (!item?.path) return;

    // element
    if (item?.element) {
      res.element = (
        <React.Suspense fallback={null}>
          {item.element}
        </React.Suspense>
      );
    }

    // children
    if (item?.children) {
      res.children = renderRoutes(item.children);
    }
    return res;
  });
}
